goog.provide("shadow.js.shim.module$src$svg$artwork$template_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$template_svg");
shadow.js.shim.module$src$svg$artwork$template_svg = shadow.js.nativeProvides["src/svg/artwork/template.svg"] = shadow$bridge("src/svg/artwork/template.svg");
module$shadow_js_shim_module$src$svg$artwork$template_svg.default = shadow.js.shim.module$src$svg$artwork$template_svg;
